import React, { Component } from 'react';
import PackagesComponent from '../../Components/Book/Packages/Packages';
import defaultPackages from '../../Constants/packages';

export default class ShootType extends Component {
	render(): React.ReactElement {
		return (
			<PackagesComponent packages={defaultPackages} />
		);
	}
}
